import React from 'react'
import { Card, Row, Col, Radio, Typography, Space, ColorPicker, Button, Divider } from 'antd'
import { useThemeStore } from '../../../shared/store/theme-store'

const { Title, Text } = Typography

interface ThemeSettingsProps {
    onSave: () => void
}

export const ThemeSettings: React.FC<ThemeSettingsProps> = ({ onSave }) => {
    const {
        primaryColor,
        setPrimaryColor,
        isDarkMode,
        toggleDarkMode,
        borderRadius,
        setBorderRadius
    } = useThemeStore()

    const presetColors = [
        { name: 'Blue', value: '#1677ff', description: 'Default blue theme' },
        { name: 'Green', value: '#10b981', description: 'Fresh green theme' },
        { name: 'Purple', value: '#7c3aed', description: 'Royal purple theme' },
        { name: 'Orange', value: '#f59e0b', description: 'Energetic orange theme' },
        { name: 'Red', value: '#ef4444', description: 'Bold red theme' },
    ]

    return (
        <div>
            <Title level={4}>Appearance</Title>
            <Text type="secondary">Customize the look and feel of the admin panel.</Text>

            <Divider />

            <Title level={5}>Color Scheme</Title>
            <Radio.Group
                value={isDarkMode ? 'dark' : 'light'}
                onChange={toggleDarkMode}
                style={{ marginBottom: 24 }}
            >
                <Radio.Button value="light">Light Mode</Radio.Button>
                <Radio.Button value="dark">Dark Mode</Radio.Button>
            </Radio.Group>

            <Title level={5}>Primary Color</Title>
            <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                {presetColors.map((color) => (
                    <Col key={color.value}>
                        <div
                            style={{
                                cursor: 'pointer',
                                border: primaryColor === color.value ? `2px solid ${color.value}` : '2px solid transparent',
                                padding: 4,
                                borderRadius: 8
                            }}
                            onClick={() => setPrimaryColor(color.value)}
                        >
                            <div style={{
                                width: 40,
                                height: 40,
                                backgroundColor: color.value,
                                borderRadius: 6
                            }} />
                            <div style={{ textAlign: 'center', fontSize: 12, marginTop: 4 }}>
                                {color.name}
                            </div>
                        </div>
                    </Col>
                ))}
                <Col>
                    <div style={{ padding: 4 }}>
                        <ColorPicker
                            value={primaryColor}
                            onChange={(c) => setPrimaryColor(c.toHexString())}
                        >
                            <div style={{
                                width: 40,
                                height: 40,
                                borderRadius: 6,
                                border: '1px dashed #d9d9d9',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer'
                            }}>
                                Custom
                            </div>
                        </ColorPicker>
                        <div style={{ textAlign: 'center', fontSize: 12, marginTop: 4 }}>
                            Custom
                        </div>
                    </div>
                </Col>
            </Row>

            <Title level={5}>Border Radius</Title>
            <Radio.Group
                value={borderRadius}
                onChange={(e) => setBorderRadius(Number(e.target.value))}
                style={{ marginBottom: 24 }}
            >
                <Radio.Button value={2}>Sharp (2px)</Radio.Button>
                <Radio.Button value={6}>Default (6px)</Radio.Button>
                <Radio.Button value={12}>Rounded (12px)</Radio.Button>
            </Radio.Group>

            <Divider />

            <Button type="primary" onClick={onSave}>Save Preferences</Button>
        </div>
    )
}
